var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-page client" },
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { staticClass: "form-page px-md-5", attrs: { cols: "12" } },
                [
                  _c("page-header", {
                    attrs: {
                      title: _vm.$tc("account.keyContact", 1),
                      subtitle: _vm.$t("account.keyContacts.subtitle"),
                      size: "col-12",
                      "container-class": "mb-4",
                    },
                  }),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("key-contact-loader")
                    : _c(
                        "div",
                        { staticClass: "card" },
                        [
                          _c(
                            "ul",
                            { staticClass: "list-group list-group-flush" },
                            [
                              _c("li", { staticClass: "list-group-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "contenedor-contacts" },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "align-items-center" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "d-lg-block d-none my-auto",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "image-cropper-sm",
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "profilepic img-fluid",
                                                  attrs: {
                                                    src: _vm._f(
                                                      "avatarPlaceholder"
                                                    )(_vm.keyContact),
                                                    alt: "",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "my-auto",
                                            attrs: {
                                              cols: "12",
                                              sm: "7",
                                              md: "3",
                                              lg: "3",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "grey-text text-darken-2 bold",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("fullName")(
                                                        _vm.keyContact
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "my-auto d-lg-block d-md-none d-block",
                                            attrs: {
                                              cols: "12",
                                              sm: "5",
                                              lg: "2",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "mgrey-text" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.keyContact
                                                        .brokerageName
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "my-auto",
                                            attrs: {
                                              cols: "12",
                                              sm: "7",
                                              md: "3",
                                              lg: "2",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "mgrey-text" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.keyContact.phoneNumber
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "my-auto",
                                            attrs: {
                                              cols: "12",
                                              sm: "5",
                                              md: "3",
                                              lg: "2",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "mgrey-text" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.keyContact
                                                        .altPhoneNumber
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "col text-sm-center text-md-left mt-sm-5 mt-4 mt-md-0",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName:
                                                      "v-b-modal.key-contact-modal",
                                                    modifiers: {
                                                      "key-contact-modal": true,
                                                    },
                                                  },
                                                ],
                                                staticClass:
                                                  "btn btn-sm btn-moregage btn-primary clickable",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.actions.emailSomeone",
                                                        {
                                                          name: _vm.keyContact
                                                            .givenName,
                                                        }
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("key-contact-modal", {
                            attrs: {
                              "contact-email": _vm.keyContact.email,
                              "contact-name": _vm.keyContact.givenName,
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }